import React from "react";
import SingleBlogCard from "./SingleBlogCard";

const BlogPostList = ({ feeds }) => {
  return (
    <div>
      <div className="mt-2">
        {feeds?.map((feed) => (
          <SingleBlogCard key={feed.id} {...feed} />
        ))}
      </div>
    </div>
  );
};

export default BlogPostList;
